import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { useTabStyles } from '../styles/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';

const Tab = forwardRef(({ children, className, startIcon: StartIcon, endIcon: EndIcon, size, onClick, isActive, isFixed, isAnimate, dataTestId, ...props }, ref) => {
    const sizes = computeResponsiveness(size);
    const styles = useTabStyles({
        sizes, isFixed, isAnimate, isActive,
    });
    return (jsxs("button", { ...props, "data-testid": dataTestId || 'tab', role: "tab", type: "button", onClick: onClick, ref: ref, className: clsx(styles.root, {
            [styles.interactive]: !isActive,
            [styles.active]: isActive,
        }, className), children: [StartIcon && (jsx(StartIcon, { className: styles.icon, "data-testid": "start-icon" })), children, EndIcon && jsx(EndIcon, { className: styles.icon, "data-testid": "end-icon" })] }));
});
Tab.displayName = 'Tab';

export { Tab };
